import { render } from "./App.vue?vue&type=template&id=2665792a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2665792a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__